import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"left":_vm.left,"top":_vm.top,"bottom":_vm.bottom,"right":_vm.right},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c(VChip,_vm._g(_vm._b({class:_vm.chipClass,attrs:{"icon":""}},'v-chip',_vm.$attrs,false),on),[_c(VIcon,{attrs:{"color":_vm.iconColor,"small":_vm.$attrs.small,"dark":_vm.dark}},[_vm._v(_vm._s(_vm.icon))])],1)]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }